export default __webpack_public_path__ + "static/media/probleme-resolu-application.4bf1273a.jpg";